// FiverrCard.jsx
import React, { useState } from "react";
import {
  FaEye,
  FaCalendarAlt,
  FaCommentDots,
  FaHeart,
  FaRegHeart,
} from "react-icons/fa";
import "./FiverrCard.css";
import { Rate } from "antd";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Avatar } from "antd";
import PlayButton from "../../assets/images/play-video-1.png";
import videoNotFound from "../../assets/images/videoNotFound.png";
import api from "../../services/api";
import useUserStatus from "../../helper/use-user-status";
const FiverrCard = ({
  image,
  title,
  description,
  rating,
  reviewsCount,
  price,
  onViewDetails,
  onSendMessage,
  setProfileImage,
  onScheduleDemo,
  handleShowReviews,
  teacherId,
  qualificationName,
  isFavorite,
  intro,
  videoThumbnail,
  onPlayVideo,
  videoPreview,
  teacherUuid,
  coverImage,
}) => {
  const user = useSelector((state) => state.auth.user);
  const teacherStatus = useUserStatus(teacherUuid);

  const [isFavorited, setIsFavorited] = useState(isFavorite || false);
  const [isFavouriting, setIsFavouriting] = useState(false);

  const toggleFavorite = async () => {
    if (isFavouriting) return; // prevent duplicate clicks
    setIsFavouriting(true);

    try {
      if (isFavorited) {
        // Remove from favorites
        await api.delete(
          `/students/${user?.id}/teachers/${teacherId}/favourites`,
        );
        toast.success("Favourite removed!");
      } else {
        // Add to favorites
        await api.post(
          `/students/${user?.id}/teachers/${teacherId}/favourites`,
        );
        toast.success("Favourite added!");
      }
      setIsFavorited(!isFavorited);
    } catch (error) {
      console.error(error);
      toast.error(error?.response?.data?.message);
    } finally {
      setIsFavouriting(false);
    }
  };

  return (
    <div className="card h-100 shadow-sm border-0">
      <div className="position-relative mb-0">
        {videoPreview ? (
          coverImage ? (
            <div style={{ position: "relative" }}>
              <img
                src={coverImage}
                className="img-fluid"
                alt="Video Thumbnail"
                style={{
                  objectFit: "cover",
                  width: "100%",
                  height: "200px",
                  borderTopLeftRadius: "8px",
                  borderTopRightRadius: "8px",
                }}
              />
              <img
                src={PlayButton}
                alt="Play Intro"
                width={55}
                onClick={onPlayVideo}
                className="cursor_pointer"
                style={{
                  position: "absolute",
                  top: "calc(50% - 18px)",
                  left: "calc(50% - 30px)",
                }}
              />
            </div>
          ) : (
            <div
              className="d-flex flex-column justify-content-center align-items-center"
              style={{
                backgroundColor: "#e0e0e0",
                height: "200px",
                width: "100%",
                textAlign: "center",
                objectFit: "contain",
                borderTopLeftRadius: "8px",
                borderTopRightRadius: "8px",
              }}
            >
              <img
                src={PlayButton}
                alt="Play Intro"
                width={55}
                onClick={onPlayVideo}
                className="cursor_pointer"
                style={{
                  opacity: 0.6,
                  marginBottom: "8px",
                }}
              />
            </div>
          )
        ) : (
          <div
            className="d-flex flex-column justify-content-center align-items-center"
            style={{
              backgroundColor: "#e0e0e0",
              height: "200px",
              width: "100%",
              textAlign: "center",
              objectFit: "contain",
              borderTopLeftRadius: "8px",
              borderTopRightRadius: "8px",
            }}
          >
            <img
              src={videoNotFound} // your placeholder play or camera icon
              alt="Video not uploaded"
              style={{
                width: "40px",
                height: "40px",
                opacity: 0.6,
                marginBottom: "8px",
              }}
            />
            {/* <div style={{ fontSize: "12px" }}>Demo not found</div> */}
          </div>
        )}
      </div>
      <div
        className="card-body d-flex flex-column"
        style={{ marginLeft: "-10px", flex: "1 0 auto" }}
      >
        {/* Title with Avatar and Favorite Icon */}
        <div
          className="d-flex justify-content-between align-items-center mb-0"
          style={{ marginTop: "-15px" }}
        >
          <div className="d-flex align-items-center mt-1">
            <div style={{ position: "relative", marginRight: "10px" }}>
              <Avatar
                src={image}
                alt="Avatar"
                size={40}
                style={{
                  border: "2px solid #d1d1d1",
                  borderRadius: "50%",
                  objectFit: "cover",
                  width: "40px",
                  height: "40px",
                }}
              />
              <div
                className={`teacher-online-status ${
                  teacherStatus === "online" ? "online" : "offline"
                }`}
              ></div>
            </div>
            <div>
              <h6 className="fw-bold mb-0" style={{ fontSize: "14px" }}>
                {title?.replace(/\b\w/g, (char) => char.toUpperCase()) ?? ""}
              </h6>
            </div>
          </div>
          <button
            className="btn btn-sm p-0 border-0 bg-transparent"
            onClick={toggleFavorite}
            disabled={isFavouriting}
            style={{
              color: isFavorited ? "#0d6efd" : "#6c757d",
              fontSize: "18px",
              cursor: isFavouriting ? "not-allowed" : "pointer",
            }}
          >
            {isFavorited ? (
              <FaHeart style={{ color: "#001529" }} />
            ) : (
              <FaRegHeart />
            )}
          </button>
        </div>

        {/* Description */}
        <p
          className="text-muted my-1"
          style={{ fontSize: "12px", minHeight: "20px" }}
        >
          {description || "-"}
        </p>
        <p
          className="text-muted mb-1"
          style={{
            fontSize: "12px",
            minHeight: "20px",
            // fontStyle: "italic",
            cursor: intro ? "pointer" : "default",
          }}
          onMouseEnter={(e) =>
            intro && (e.target.style.textDecoration = "underline")
          }
          onMouseLeave={(e) =>
            intro && (e.target.style.textDecoration = "none")
          }
          onClick={intro ? onViewDetails : undefined}
        >
          {/* {intro && intro.length > 0 ? `${intro.slice(0, 100)}${intro.length > 100 ? "..." : ""}` : "-"} */}
          {intro && intro.length > 0
            ? intro.length > 100
              ? `${intro.slice(0, intro.lastIndexOf(" ", 100)).trim()}${
                  intro.length > 100 ? "..." : ""
                }`
              : intro
            : "-"}
        </p>

        {/* Qualification Name */}
        {/*  <p
          className="text-muted mb-1"
          style={{ fontSize: "12px", minHeight: "20px" }}
        >
          {qualificationName || "-"}
        </p> */}

        {/* Rating */}
        <div className="pb-0" style={{ fontSize: "10px", minHeight: "20px" }}>
          <span className="fw-bold">
            <Rate
              onClick={handleShowReviews}
              disabled
              value={rating || 0}
              style={{ fontSize: "12px", marginRight: "5px" }}
            />
            ({reviewsCount || 0})
          </span>
        </div>

        {/* Price */}
        {/*         <div className="fw-bold" style={{ fontSize: "12px", minHeight: "20px" }}>
          {price ? `From PKR ${price}` : "Price not available"}
        </div> */}

        {/* Action Buttons */}
        <div
          className="mt-auto d-flex justify-content-center gap-2 align-items-center"
          style={{ minHeight: "40px", paddingTop: "10px" }}
        >
          <IconButtonWithTooltip
            icon={<FaEye size={25} />}
            tooltip="View Details"
            onClick={onViewDetails}
          />
          {(!user || user?.role === "student") && (
            <>
              <IconButtonWithTooltip
                icon={<FaCommentDots size={25} />}
                tooltip="Send a Message"
                onClick={() => {
                  onSendMessage();
                  setProfileImage(image);
                }}
              />
              <IconButtonWithTooltip
                icon={<FaCalendarAlt size={25} />}
                tooltip="Schedule a Demo"
                onClick={onScheduleDemo}
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default FiverrCard;

// Separate small reusable IconButtonWithTooltip component
const IconButtonWithTooltip = ({ icon, tooltip, onClick }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className="position-relative d-flex align-items-center"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <button
        className="btn btn-sm rounded-circle d-flex justify-content-center align-items-center"
        onClick={onClick}
        style={{
          width: "30px",
          height: "30px",
          backgroundColor: "#F5F5F5",
          color: "#001529",
          border: "none",
          transition: "all 0.3s",
          fontSize: "14px",
          cursor: "pointer", // ✅ cursor pointer added
        }}
      >
        {React.cloneElement(icon, {
          // color: isHovered ? "#ffffff" : "#0d6efd",
        })}
      </button>
      <div className="custom-tooltip">{tooltip}</div>
    </div>
  );
};
